import {
  InvoiceRow,
  InvoiceStatus,
  PayoutSettings,
  PreferredPayoutSpeed
} from "@wingspanhq/wingspan-api-sdk";

/**
 * Whether the payee may request an instant payout for a paid-but-not-yet-
 * deposited invoice. On v3 the "paid, awaiting deposit" gate reads the row's
 * raw `status === Paid` plus `!events.depositedAt` (both on the search row).
 *
 * Accepted regression (V3_MIGRATION_TRACKER.md): the v1 per-invoice
 * `amountDetails` presence check and the invoice-level `member.payoutPreferences
 * !== Instant` check are dropped — neither is on the v3 row. The payout-speed
 * preference is still enforced via the account's `PayoutSettings`. The v1
 * enterprise-account gate (`user.settings.userAccountType`) is also dropped —
 * v3 has no equivalent field yet (same gap as
 * `useGetDashboardFocusedFeaturesContext.ts`'s `userType`), so enterprise
 * accounts may now see this option where they previously didn't.
 */
export const selectorIsInstantPayoutAllowed = (
  invoice: InvoiceRow,
  payoutSettings?: PayoutSettings,
  isDomestic?: boolean
) =>
  !!payoutSettings &&
  !!isDomestic &&
  invoice.status === InvoiceStatus.PAID &&
  !invoice.events?.depositedAt &&
  payoutSettings.preferredPayoutSpeed !== PreferredPayoutSpeed.INSTANT;
